import React from "react";
import { FiSettings } from "react-icons/fi";
import { Link } from "react-router-dom";

import classes from "./styles.module.scss";
import store from "../../../../store/store";
import { USER_ROLES } from "../../../../enum/UserRoles";

export const AdminTitle = (props) => {
  const Mobile = props.mobile;

  const { auth } = store.getState();

  return (
    <header className={classes.headerWrapper}>
      <div
        className={classes.header}
        style={props.removeMargin && { margin: 0 }}
      >
        {!props.hideTitle && (
          <div className={classes.titleContainer}>
            <div className={classes.titleIcon}>
              {props.icon ? props.icon : <FiSettings size="30px" color="red" />}
            </div>
            <h1 className={classes.title}>{props.title}</h1>
          </div>
        )}
        {props.addButtonUrl &&
          (auth?.user?.role === USER_ROLES.ADMIN ||
            auth?.user?.role === USER_ROLES.COLLABORATOR) && (
            <Link
              to={props.addButtonUrl}
              className={classes.addButton}
              style={{
                width: "30px",
              }}
              title={props.tooltip}
            >
              {props.titleButon}
            </Link>
          )}
      </div>
      {props.disableHeader ? null : props.width >= 768 ||
        !props.mobile ? null : (
        <div>
          <Mobile
            actions={props.actions || null}
            width={props.width}
            buttons={props.generateMobileButtons}
            refreshAction={() => props.refreshAction}
          />
        </div>
      )}
      {!props.hideTitle && <div className={classes.line} />}
    </header>
  );
};
